<template>
  <div id="password-change">
    <v-container grid-list-xl>
      <v-layout row wrap>
        <v-flex xs12>
          <v-dialog v-model="dialog" max-width="600px"
            :close-on-content-click="false"
            transition="scale-transition"
          >
            <v-btn
              color="info"
              slot="activator"
              @click="resetERRORpasswd()"
              
            >
              <v-icon dark left>security</v-icon> Modifier le mot de passe
            </v-btn>
            <v-card>
              <v-layout align-end justify-end>
                <v-btn icon  @click="dialog = false">
                  <v-icon>close</v-icon>
                </v-btn>
              </v-layout>
              <v-form>
                <v-card-text>
                  <v-container grid-list-md>
                    <v-layout wrap>
                      <v-flex xs12>
                        <v-text-field v-model="inputs.new_password1" label="Nouveau mot de passe*" type="password" required></v-text-field>
                      </v-flex>
                      <v-flex xs12>
                        <v-text-field v-model="inputs.new_password2" label="Confirmer nouveau mot de passe*" type="password" required></v-text-field>
                      </v-flex>
                    </v-layout>
                  </v-container>
                </v-card-text>
                <v-card-actions>
                  <v-layout wrap>
                    <v-flex xs12>
                      <h6 v-if="changePasswdError" class="warning title white--text mb-3 text-xs-center"><v-icon dark>error_outline</v-icon></h6>
                      <h6 v-for="(error, index) in changePasswdRaisonError" :key="index" class=" title warning--text mb-3">{{ error }}</h6>
                    </v-flex>
                    <v-spacer></v-spacer>
                    <v-flex xs6><v-btn color="info" @click="changePassword(inputs)">Changer le mot de passe</v-btn></v-flex>
                    <v-flex xs6><small>*Champs requis</small></v-flex>
                  </v-layout>
                </v-card-actions>
              </v-form>
            </v-card>
          </v-dialog>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>


<script>

import { mapActions, mapState } from 'vuex';

export default {
  computed: mapState('password', [
    'changePasswdError',
    'changePasswdRaisonError',
  ]),
  data: function() {
    return {
      inputs: {
        new_password1: '',
        new_password2: '',
      },
      dialog: false,
    }
  },
  methods: {
      ...mapActions('password', [
      'changePassword',
      'resetERRORpasswd',
    ]),
  },
}
</script>



